/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cases_Col_Third_Party_DataInputs */

const en_cases_col_third_party_data = /** @type {(inputs: Cases_Col_Third_Party_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Third Party`)
};

const pt_br2_cases_col_third_party_data = /** @type {(inputs: Cases_Col_Third_Party_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terceiro`)
};

/**
* | output |
* | --- |
* | "Third Party" |
*
* @param {Cases_Col_Third_Party_DataInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const cases_col_third_party_data = /** @type {((inputs?: Cases_Col_Third_Party_DataInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_Col_Third_Party_DataInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cases_col_third_party_data(inputs)
	return pt_br2_cases_col_third_party_data(inputs)
});